/**
 * Created by Andrey Popov on 14.03.2024
 */

const QuestInfoView = cc.Node.extend({
    ctor: function (quest, options, questsGroupIcon) {
        this._super();
        this.options = options || {};
        this.questsGroupIcon = questsGroupIcon;

        this.quest = quest;
        this.questIcon = this.options.iconView;

        const styles = cleverapps.styles.QuestInfoView;

        if (this.isCompact()) {
            this.setContentSize2(styles.compact);

            this.setAnchorPoint(0, 0.5);

            this.bg = new cc.Scale9Sprite(bundles.questinfo.frames.details_bg);
            this.addChild(this.bg);
            this.bg.setContentSize2(this.getContentSize());
            this.bg.setAlignment(this.width / 2, this.height / 2);

            const checkMark = new cc.Sprite(bundles.questinfo.frames.quests_thumbs_up);
            checkMark.setAlignment(this.bg.width / 2, this.bg.height / 2);
            this.addChild(checkMark);

            this.arrow = new cc.Sprite(bundles.questinfo.frames.arrow_comp_details);
            this.arrow.setAlignment(styles.compact.arrow);
            this.addChild(this.arrow);
        } else {
            this.addContent();
        }

        this.updatePosition();

        if (this.isCompletion()) {
            this.showCompletion();
        } else {
            this.show();
        }

        this.setCascadeOpacityEnabled(true);
    },

    addContent: function () {
        const styles = cleverapps.styles.QuestInfoView.regular;

        this.bg = new cc.Scale9Sprite(bundles.questinfo.frames.details_bg);
        this.addChild(this.bg);

        const title = this.createTitle();
        title.setAlignment(styles.title);
        this.addChild(title);

        const debugButton = this.configLinkButton();
        if (debugButton) {
            title.addChild(debugButton);
        }

        this.iconBg = this.createIcon();
        this.iconBg.setAlignment(styles.icon);
        this.addChild(this.iconBg);

        const rewards = this.createRewards();
        rewards.setAlignment(styles.rewards);
        this.addChild(rewards);

        this.setContentSize(styles.width, styles.height + title.height);

        this.bg.setContentSize2(this.getContentSize());
        this.bg.setAlignment(this.width / 2, this.height / 2);

        this.arrow = new cc.Sprite(bundles.questinfo.frames.arrow_details);
        this.arrow.setAlignment(styles.arrow.x, this.height - title.height / 2 + styles.arrow.offsetY);
        this.addChild(this.arrow);

        this.setAnchorPoint(0, this.arrow.y / this.height);
    },

    createTitle: function () {
        const styles = cleverapps.styles.QuestInfoView.regular;

        const titleBg = new cc.Scale9Sprite(bundles.questinfo.frames.details_title);

        const title = cleverapps.UI.generateOnlyText(this.quest.getTitle(), cleverapps.styles.FONTS.QUESTPANEL_CAPTION);
        const titleBgHeight = Math.min(title.height + 2 * styles.title.padding.y, styles.title.maxHeight);
        titleBg.setContentSize(styles.title.width, titleBgHeight);
        title.fitTo(styles.title.width - 2 * styles.title.padding.x, titleBgHeight - 2 * styles.title.padding.y);
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        title.setAlignment(titleBg.width / 2, titleBg.height / 2);
        titleBg.addChild(title);

        return titleBg;
    },

    configLinkButton: function () {
        const questsConfigBundleName = `quests_${cleverapps.meta.selectedLocationId()}`;
        let debugButton;
        if (cleverapps.config.debugMode && bundles[questsConfigBundleName] && bundles[questsConfigBundleName].jsons.questsconfig_json && bundles[questsConfigBundleName].jsons.questsconfig_json.resolve()) {
            debugButton = new cleverapps.UI.Button({
                type: cleverapps.styles.UI.Button.Images.small_button_green,
                content: new cc.Sprite(bundles.dev_buttons.frames.icon_edit),
                onClicked: () => {
                    const originalPath = bundles[questsConfigBundleName].jsons.questsconfig_json.resolve().originalPath();

                    const repo = originalPath.substring(0, originalPath.indexOf("/"));
                    const resPath = originalPath.substring(repo.length);

                    const link = `https://github.com/Clever-Apps-Pte-Ltd/${repo}/tree/master${resPath}`;
                    console.log(`Quest config: \n${link}`);

                    connector.platform.openUrl(link);
                    cleverapps.copyToClipboard(this.quest.id);
                },
                hint: "Open link to quest config"
            });
            debugButton.setAlignment(cleverapps.styles.QuestInfoView.debugButton);
        }
        return debugButton;
    },

    createIcon: function () {
        const styles = cleverapps.styles.QuestInfoView.regular;

        const iconBg = new cc.Scale9Sprite(bundles.questinfo.frames.item_icon);
        iconBg.setContentSize(styles.icon);
        const icon = QuestIcon.getIconImage(this.quest);
        cleverapps.UI.fitToBox(icon, {
            width: 0.8 * iconBg.width,
            height: 0.8 * iconBg.height,
            maxScale: 1.6
        });
        icon.setAlignment(iconBg.width / 2, iconBg.height / 2 + styles.icon.offsetY);
        iconBg.addChild(icon);
        return iconBg;
    },

    createRewards: function () {
        const styles = cleverapps.styles.QuestInfoView.regular;

        const rewardsTitle = cleverapps.UI.generateOnlyText(Messages.get("RewardsListComponent.rewardTitle"), cleverapps.styles.FONTS.QUESTPANEL_REWARDS);
        const rewardsList = this.rewardsList = new RewardsListComponent(this.quest.rewards, {
            font: cleverapps.styles.FONTS.QUESTPANEL_REWARDS,
            columns: 6,
            noPrefix: true,
            small: true,
            textDirection: cleverapps.UI.HORIZONTAL,
            noShowControls: true
        });

        cleverapps.UI.fitToBox(rewardsList, {
            width: styles.fitToBox.width
        });

        return new cleverapps.Layout([rewardsTitle, rewardsList], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.rewards.margin
        });
    },

    hide: function () {
        this.stopAllActions();

        this.runAction(
            new cc.Sequence(
                new cc.Spawn(
                    new cc.ScaleTo(0.15, 0).easing(cc.easeIn(2)),
                    new cc.FadeOut(0.15).easing(cc.easeIn(2))
                ),
                new cc.RemoveSelf()
            )
        );
    },

    updatePosition: function () {
        const styles = cleverapps.styles.QuestInfoView;

        const parent = this.questsGroupIcon.onGetView();

        const questIconPosition = parent.convertToNodeSpace(this.questIcon.parent.convertToWorldSpace(this.questIcon.getPosition()));
        const scene = cleverapps.Scenes.GetRunningScene();

        const position = cc.p(parent.width + styles.padding + this.arrow.width, questIconPosition.y);

        const globalPosition = scene.convertToNodeSpace(parent.convertToWorldSpace(position));
        this.baseScale = Math.max(0.3, Math.min(1, (scene.width - globalPosition.x - styles.padding) / this.width));

        this.setScale(this.baseScale);
        this.setPosition(position);
    },

    onResize: function () {
        this.questsGroupIcon.hideInfo();
    },

    show: function () {
        this.stopAllActions();

        this.setVisible(false);

        if (this.isCompact()) {
            const styles = cleverapps.styles.QuestInfoView.compact;
            this.runAction(new cc.Sequence(
                new cc.ScaleTo(0, 0.2 * this.baseScale),
                new cc.Show(),
                new cc.ScaleTo(0.2, this.baseScale).easing(cc.easeBackOut()),
                new cc.MoveBy(styles.duration, styles.delta, 0).easing(cc.easeInOut(1.7)),
                new cc.MoveBy(styles.duration, -styles.delta, 0).easing(cc.easeInOut(1.7)),
                new cc.MoveBy(styles.duration, styles.delta, 0).easing(cc.easeInOut(1.7)),
                new cc.MoveBy(styles.duration, -styles.delta, 0).easing(cc.easeInOut(1.7)),
                new cc.CallFunc(() => {
                    this.hide();
                })
            ));
        } else {
            this.runAction(new cc.Sequence(
                new cc.DelayTime(this.options.delay || 0),
                new cc.CallFunc(this.updatePosition.bind(this)),
                new cc.ScaleTo(0, 0.22 * this.baseScale, 0.2 * this.baseScale),
                new cc.Show(),
                new cc.ScaleTo(0.2, 1.05 * this.baseScale, 0.95 * this.baseScale).easing(cc.easeInOut(2)),
                new cc.ScaleTo(0.15, 0.95 * this.baseScale, 1.05 * this.baseScale).easing(cc.easeInOut(2)),
                new cc.ScaleTo(0.1, this.baseScale, this.baseScale).easing(cc.easeInOut(2)),
                new cc.DelayTime(this.options.duration || 5),
                new cc.CallFunc(this.hide.bind(this))
            ));
        }
    },

    showCompletion: function () {
        this.stopAllActions();

        this.setVisible(false);

        this.runAction(new cc.Sequence(
            new cc.ScaleTo(0, 0.2 * this.baseScale),
            new cc.CallFunc(() => {
                this.questIcon.highlight && this.questIcon.highlight(0.53);
            }),
            new cc.DelayTime(0.33),
            new cc.CallFunc(this.updatePosition.bind(this)),
            new cc.Show(),
            cleverapps.effects.fireAction("quests.completed"),
            new cc.ScaleTo(0.1, 1.1 * this.baseScale, this.baseScale),
            new cc.ScaleTo(0.04, 0.9 * this.baseScale, 1.1 * this.baseScale).easing(cc.easeOut(2)),
            new cc.ScaleTo(0.04, this.baseScale, this.baseScale).easing(cc.easeIn(2)),
            new cc.DelayTime(0.33),
            new cc.CallFunc(() => {
                const checkmark = new cc.Sprite(bundles.questinfo.frames.quests_mark);
                checkmark.setAnchorPoint(0.5, 0.5);
                checkmark.setAlignment(cleverapps.styles.QuestInfoView.regular.icon.checkmark);
                this.iconBg.addChild(checkmark);

                checkmark.setScale(1.7);
                checkmark.setOpacity(0.3);
                checkmark.runAction(new cc.Sequence(
                    new cc.FadeIn(0.06),
                    new cc.ScaleTo(0.2, 0.9).easing(cc.easeOut(1)),
                    new cc.ScaleTo(0.06, 1)
                ));

                const confetti = new cleverapps.Spine(bundles.questinfo.jsons.confetti_quests);
                confetti.setAnchorPoint(0.5, 0.5);
                confetti.setAlignment(this.width / 2, this.height / 2);
                confetti.setAnimation(0, "animation", false);
                confetti.setCompleteListenerRemove();
                this.addChild(confetti);

                const shine = new cleverapps.Spine(bundles.questinfo.jsons.big_shine_quests);
                shine.setAnchorPoint(0.5, 0.5);
                shine.setAlignment(this.width / 2, this.height / 2);
                shine.setAnimation(0, "animation", false);
                shine.setCompleteListenerRemove();
                this.addChild(shine, -1);

                const glowTop = new cleverapps.Spine(bundles.questinfo.jsons.linear_glow_quests);
                glowTop.setAnchorPoint(0.5, 0.5);
                glowTop.setAlignment(this.width / 2, this.height);
                glowTop.setAnimation(0, "animation", false);
                glowTop.setCompleteListenerRemove();
                this.addChild(glowTop);

                const glowBottom = new cleverapps.Spine(bundles.questinfo.jsons.linear_glow_quests);
                glowBottom.setAnchorPoint(0.5, 0.5);
                glowBottom.setAlignment(this.width / 2, 0);
                glowBottom.setAnimation(0, "animation", false);
                glowBottom.setCompleteListenerRemove();
                this.addChild(glowBottom);
            }),
            new cc.ScaleTo(0.13, 1.1 * this.baseScale).easing(cc.easeOut(2)),
            new cc.ScaleTo(0.13, this.baseScale).easing(cc.easeIn(2)),
            new cc.DelayTime(0.26),
            new cc.CallFunc(() => {
                this.rewardsList.receiveRewardsAnimation({
                    noFadeOut: true
                });
            }),
            new cc.DelayTime(0.2),
            new cc.Spawn(
                new cc.ScaleTo(0.13, 0).easing(cc.easeIn(2)),
                new cc.FadeOut(0.13).easing(cc.easeIn(2))
            ),
            new cc.RemoveSelf()
        )).setFinalize(() => {
            this.rewardsList.reward.updateViewAmount();
            this.options.callback();
        });
    },

    isCompact: function () {
        return this.options.compact;
    },

    isCompletion: function () {
        return this.options.callback;
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    QUESTPANEL_CAPTION: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    QUESTPANEL_REWARDS: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        size: 44
    }
});

cleverapps.styles.QuestInfoView = {
    padding: 10,

    regular: {
        width: 620,
        height: 250,

        title: {
            width: 620,
            maxHeight: 140,

            paddingDimensionX: 15,
            padding: {
                x: 35,
                y: 15
            },

            x: { align: "center", dx: 0 },
            y: { align: "top", dy: 0 }
        },

        icon: {
            width: 160,
            height: 160,

            x: { align: "center", dx: -190 },
            y: { align: "bottom", dy: 50 },

            offsetY: 10,

            checkmark: {
                x: { align: "right", dx: 24 },
                y: { align: "top", dy: 14 }
            }
        },

        rewards: {
            x: { align: "center", dx: 104 },
            y: { align: "bottom", dy: 78 },
            margin: 0
        },

        arrow: {
            x: { align: "left", dx: -38 },
            offsetY: -5
        },

        fitToBox: {
            width: 340
        }
    },

    compact: {
        width: 148,
        height: 142,

        arrow: {
            x: { align: "left", dx: -38 },
            y: { align: "top", dy: -42 }
        },

        duration: 0.5,
        delta: 25
    },

    debugButton: {
        x: { align: "right", dx: -10 },
        y: { align: "center", dy: 0 }
    }
};